// extracted by mini-css-extract-plugin
export var SectionTitle = "SectionTitle-module--SectionTitle--b3d16";